import { Box, Flex, Icon, Input, InputGroup } from '@chakra-ui/react';
import { MdSearch as SearchIcon, MdClose as ClearIcon, MdTune as FilterIcon } from 'react-icons/md';

interface HomeSearchBarProps {
  value: string;
  onChange: (value: string) => void;
  onFilterClick?: () => void;
  totalActive?: number;
  noPx?: boolean;
  placeholder?: string;
  /** Override what happens when the inline ✕ is clicked. Defaults to onChange(''). */
  onClear?: () => void;
}

export default function HomeSearchBar({
  value,
  onChange,
  onFilterClick,
  totalActive = 0,
  noPx = false,
  placeholder = 'Search recipes…',
  onClear,
}: HomeSearchBarProps) {
  return (
    <Flex gap={2} px={noPx ? 0 : 4} pb={noPx ? 0 : 2} align="center">
      <InputGroup
        flex={1}
        startElement={<SearchIcon color="var(--chakra-colors-text-muted)" />}
        endElement={
          value ? (
            <Box
              as="button"
              aria-label="Clear search"
              onClick={() => onClear ? onClear() : onChange('')}
              color="text.muted"
              display="flex"
              alignItems="center"
            >
              <ClearIcon size={16} />
            </Box>
          ) : undefined
        }
      >
        <Input
          placeholder={placeholder}
          value={value}
          onChange={e => onChange(e.target.value)}
          bg="bg.surface"
          border="1.5px solid"
          borderColor="border.default"
          borderRadius="full"
          boxShadow="0 1px 4px rgba(0,0,0,0.08)"
          _focus={{
            borderColor: 'accent.secondary',
            boxShadow: '0 0 0 2px var(--chakra-colors-accent-secondary)',
          }}
          _placeholder={{ color: 'text.muted' }}
        />
      </InputGroup>

      {/* Filter icon — mobile only */}
      {onFilterClick && (
        <Box
          as="button"
          aria-label="Open filters"
          onClick={onFilterClick}
          display={{ base: 'flex', lg: 'none' }}
          w="40px"
          h="40px"
          borderRadius="full"
          border="1.5px solid"
          borderColor="border.muted"
          bg="bg.surface"
          alignItems="center"
          justifyContent="center"
          flexShrink={0}
          cursor="pointer"
          position="relative"
          transition="all 0.15s"
        >
          <Icon
            as={FilterIcon}
            boxSize="18px"
            color={totalActive > 0 ? 'accent.emphasis' : 'text.muted'}
          />
          {totalActive > 0 && (
            <Box
              position="absolute"
              top="-3px"
              right="-3px"
              w="15px"
              h="15px"
              borderRadius="full"
              bg="accent.secondary"
              fontSize="9px"
              fontWeight="700"
              color="white"
              display="flex"
              alignItems="center"
              justifyContent="center"
              lineHeight="1"
            >
              {totalActive}
            </Box>
          )}
        </Box>
      )}
    </Flex>
  );
}
